export default __webpack_public_path__ + "static/phone-canada_us-btn-7350d095db8e7ec6c613a6f65f22abc8.png";